import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class BlockStorageDetailsRoute extends Route {
  @service store;

  async model(params) {
    const { project } = this.modelFor("organization");
    const volumes = await project.get("blockStorageVolumes");
    const servers = await project.get("servers");
    const dataCenters = this.store.peekAll("data-center");
    const volume = volumes.find((volume) => volume.id === params.block_storage_volume_id);

    return { project, volume, servers, dataCenters };
  }
}
